import { useTheme } from 'lib/context/ThemeContext';

const IconYoutube = (): JSX.Element => {
  const { themeName } = useTheme();
  return themeName === 'aw' ? (
    <svg
      role="img"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Youtube Icon</title>
      <path
        d="M9.53896 7.86083L7.66729 6.9875C7.50396 6.91167 7.36979 6.99667 7.36979 7.1775V8.8225C7.36979 9.00333 7.50396 9.08833 7.66729 9.0125L9.53813 8.13917C9.70229 8.0625 9.70229 7.9375 9.53896 7.86083ZM8.20312 0C3.78479 0 0.203125 3.58167 0.203125 8C0.203125 12.4183 3.78479 16 8.20312 16C12.6215 16 16.2031 12.4183 16.2031 8C16.2031 3.58167 12.6215 0 8.20312 0ZM8.20312 11.25C4.10813 11.25 4.03646 10.8808 4.03646 8C4.03646 5.11917 4.10813 4.75 8.20312 4.75C12.2981 4.75 12.3698 5.11917 12.3698 8C12.3698 10.8808 12.2981 11.25 8.20312 11.25Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      role="img"
      width="32"
      height="32"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Youtube Icon</title>
      <path
        d="M9.53896 7.86083L7.66729 6.9875C7.50396 6.91167 7.36979 6.99667 7.36979 7.1775V8.8225C7.36979 9.00333 7.50396 9.08833 7.66729 9.0125L9.53813 8.13917C9.70229 8.0625 9.70229 7.9375 9.53896 7.86083ZM8.20312 0C3.78479 0 0.203125 3.58167 0.203125 8C0.203125 12.4183 3.78479 16 8.20312 16C12.6215 16 16.2031 12.4183 16.2031 8C16.2031 3.58167 12.6215 0 8.20312 0ZM8.20312 11.25C4.10813 11.25 4.03646 10.8808 4.03646 8C4.03646 5.11917 4.10813 4.75 8.20312 4.75C12.2981 4.75 12.3698 5.11917 12.3698 8C12.3698 10.8808 12.2981 11.25 8.20312 11.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconYoutube;
